import api from "lib/api";
import { ConversationStatParams } from "actions/dashboard";

export const fetchConversationStats = ({ start, end, period }: ConversationStatParams) => {
  return api.get(`/dashboard/conversation_stats?startDate=${start}&endDate=${end}&period=${period}`);
};
